import React, {useEffect} from 'react';

import {SurveyNameTableColumn} from './NameTableColumn';
import {StreamBankTable} from "../../Common/Table/StreamBankTable";
import {OrganizationNameTableColumn} from "../Organizations/OrganizationNameTableColumn";
import {service as ConservationActionTypeService} from "../../../Services/ConservationActionTypeService";
import {service as SurveyTypeService} from "../../../Services/SurveyTypeService";
import {TextTableColumn} from "../../Common/Tables/TextTableColumn";
import {ContextNodesTableColumn} from "../../Common/FileBrowser/ContextNodesTableColumn";

export const SurveysTable = React.forwardRef((props, ref) => {

    SurveyTypeService.PrimeCache();
    ConservationActionTypeService.PrimeCache();
    
    const surveyNameLogic = (survey) => {
        if(!SurveyTypeService.cached || !ConservationActionTypeService.cached) {
            return "Loading...";
        }
        
        const surveyKind = survey.organizationId === null ? 'Default' : 'Custom';
        const conservationAction = ConservationActionTypeService.CachedValueById(survey.conservationActionTypeId)?.result;
        const surveyType = SurveyTypeService.CachedValueById(survey.surveyTypeId)?.result;

        if(conservationAction && surveyType) {
            return `${conservationAction.name} - ${surveyType.name} (${surveyKind})`;
        } else {
            return 'N/A';
        }
    }

    const columnDefs = [
        {
            title: "Name",
            key: "name",
            sortable: true,
            logic: surveyNameLogic,
            renderer: SurveyNameTableColumn
        },
        {
            title: "Organization",
            key: "organization",
            sortable: true,
            logic: (x) => x?.Organization?.name ?? 'All Organizations',
            renderer: OrganizationNameTableColumn
        },
        {
            title: "Programs",
            key: "programs",
            sortable: true,
            headerClassName: "programs",
            logic: (x) => x?.SurveyPrograms,
            renderer: (props) => <ContextNodesTableColumn emptyMessage={"(Default)"} {...props} />,
        },
        {
            title: "Published",
            key: "published",
            sortable: true,
            logic: (x) => x?.published ? 'Yes' : 'No',
            renderer: TextTableColumn
        },
    ];
    
    return <StreamBankTable
        columnDefs={columnDefs}
        itemNamePlural="surveys"
        getKeyForRow={x => x.surveyId}
        usesContext={false}

        ref={ref}

        {...props}
        sortColumn="organization"
        sortAsc={true}

    />;
});


